<html lang="fr">
<head>
  <!-- Le head contient normalement des métadonnées et des liens vers des feuilles de style, mais ici il est vide -->
</head>
<body>

<!-- Conteneur principal qui enveloppe tout le contenu de la page -->
<div class="container">
    <!-- Premier logo affiché avec une classe spécifique pour le style -->
    <img src="../../../assets/Vendeur-site-smallversion2.png" alt="CodinCloud Logo" class="logo1">
    
    <!-- Deuxième logo affiché avec une autre classe spécifique -->
    <img src="../../../assets/icon-vendeur-transparent-01.png" alt="CodinCloud Logo" class="logo">
    
    <!-- Titre indiquant à l'utilisateur ce qu'il doit faire -->
    <h3>Entrer votre email</h3>
    
    <!-- Formulaire de saisie d'email avec validation -->
    <form [formGroup]="testForm" (ngSubmit)="onSubmit()">
        <!-- Label pour le champ de saisie d'email -->
        <label for="input">Adresse Email</label>
        
        <!-- Champ de saisie pour l'email avec des propriétés Angular -->
        <input matInput type="text" id="input" formControlName="input" placeholder="Entrez Adresse Email" required>
        
        <!-- Bouton pour soumettre le formulaire, il est désactivé si le formulaire est invalide -->
        <button mat-raised-button color="primary" type="submit" [disabled]="testForm.invalid">Envoyer</button>
    </form>

    <!-- Section affichant un message de réponse si une réponse est disponible -->
    <div *ngIf="message" class="response-message">
        <!-- Le message est affiché ici lorsque la variable 'message' est définie -->
        <p>{{ message }}</p>
    </div>
</div>

</body>
</html>
